module.exports = __webpack_public_path__ + "static/media/9DESA3.ff81d228.jpg";